import { useEffect, useState } from 'react';
import { getAdvertisement } from '../../../redux/actions/advertisement';
import { sameList, sortByRank } from './playlist';

// Often enough that a schedule or an edit shows up the same day, rarely enough to cost nothing.
export const REFRESH_MS = 5 * 60 * 1000;

// The ads this screen plays. `shape` is 'portrait' or 'landscape'. A refresh that fails keeps what is playing.
export const useAdvertisements = (shape) => {
    const [ads, setAds] = useState([]);

    useEffect(() => {
        let cancelled = false;

        const load = () =>
            getAdvertisement({ orientation: shape }).then((res) => {
                if (cancelled || !res?.ack) return;
                const next = sortByRank(res.advertisements || res.data || []);
                setAds((current) => (sameList(current, next) ? current : next));
            });

        load();
        const timer = setInterval(load, REFRESH_MS);
        return () => {
            cancelled = true;
            clearInterval(timer);
        };
    }, [shape]);

    return ads;
};
